import React, { Component } from "react";
import MainWrapper from "../wrappers/MainWrapper"; 
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { reduxForm, Field, reset } from "redux-form";
import CustomTextField from "../../components/fields/CustomTextField";
import { changePasswordStyle } from '../../utils/Style';

import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { connect } from "react-redux";
import Grid from '@material-ui/core/Grid';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckIcon from '@material-ui/icons/CheckCircle';
import { updatepassword, checkPackage, checkUserRole } from "../../actions";
import NotificationSnackBar from '../../utils/NotificationSnackBar';
/*
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js'; 
  import { Bar,Chart } from 'react-chartjs-2'; 
*/
export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top'  ,
    },
    title: {
      display: true,
      text: 'RSPO info Chart',
    },
  },
};


const labels1 = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
const labels2 = ['Total Pending', 'Total Uploaded'];
 
function getModalStyle() {
    return {
        top: `${50}%`,
        left: `${50}%`,
        transform: `translate(-${50}%, -${50}%)`,
    };
}

const required_fields = [
    { name: "oldPassword", label: "Old Password" },
    { name: "newPassword", label: "New Password" },
    { name: "confirmPassword", label: "Confirm Password" },
];
const data = {
    labels2,
    datasets: [
      {
        label: 'Total Pending',
        data: labels2.map(() => 504),
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
      },
      {
        label: 'Total Uploaded',
        data: labels2.map(() => 349),
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
    ],
  };

  
const labels = ['January', 'February', 'March', 'April', 'May', 'June'];
const total = [103,302, 147, 125, 104, 9];
const modis = [11, 32,5,3,6,0];
const viirs = [52, 133, 71,69, 44,4];
const noaa = [40,137, 71,53, 54, 5];
 
const uploaded = [61, 114, 62, 58, 38, 2 ];
const notified = [42, 188, 85, 67, 66, 7]; 
export const data3 = {
  labels,
  datasets: [
    {
      type: 'line' ,
      label: 'Total Hotspot',
      borderColor: 'rgb(255, 99, 132)',
      borderWidth: 2,
      fill: false,
      data: total,
    },
    {
      type: 'bar' ,
      label: 'Total Submitted',
      backgroundColor: 'rgb(75, 192, 192)',
      data: uploaded,
      borderColor: 'white',
      borderWidth: 2,
    },
    {
      type: 'bar' ,
      label: 'Total Notified',
      backgroundColor: 'rgb(53, 162, 235)',
      data: notified,
    }
  ],
};

export const data2 = {
    labels,
  datasets: [
    {
      type: 'line' ,
      label: 'Total Hotspot',
      borderColor: 'rgb(255, 99, 132)',
      borderWidth: 2,
      fill: false,
      data: total,
    },
    {
      type: 'bar' ,
      label: 'Modis',
      backgroundColor: 'rgb(75, 192, 192)',
      data: modis,
      borderColor: 'white',
      borderWidth: 2,
    },
    {
      type: 'bar' ,
      label: 'VIIRS',
      backgroundColor: 'rgb(53, 162, 235)',
      data: viirs,
    },{
      type: 'bar' ,
      label: 'NOAA',
      backgroundColor: 'rgb(0, 102, 235)',
      data: noaa,
    }
  ],
};

class Dashboard extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            open: false,
            isSwitchSnackbarOn: false,
            isSnackbarError: false,
            isCancel: true
        };
        console.log(this.props);
        this.chartReference = React.createRef();
        this.chartReference2 = React.createRef();
        this.chartReference3 = React.createRef();
        this.handleModalOpen = this.handleModalOpen.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
    }

    

    _handleSubmit = values => {
        this.handleModalClose();
        this.props.updatepassword(values, this.props.history);
    };
 
    componentWillReceiveProps(updatePasswordResult) {
        if (updatePasswordResult.updatePasswordResult != this.props.updatePasswordResult) {
            this.updateSnackbarStatus(updatePasswordResult.updatePasswordResult);
        } else {
            this.updateSnackbarStatusFalse();
        }
    }

    
componentWillMount() {
  }

componentDidMount(){
    this.props.checkUserRole();
    console.log(this.chartReference);
    console.log(this.chartReference2);  
}
    updateSnackbarStatus = (snackbarObject) => {
        this.setState({
            isSnackbarError: snackbarObject.isSnackbarError,
            isSwitchSnackbarOn: snackbarObject.isSwitchSnackbarOn,
            snackbarErrorMessage: snackbarObject.ErrorMessage
        })
    }

    updateSnackbarStatusFalse = () => {
        if (this.state.isSwitchSnackbarOn) {
            this.setState({ isSwitchSnackbarOn: false })
        }
    }

    handleModalOpen = () => {
        this.setState({
            open: true,
        });
    };

    handleModalClose = () => {
        this.setState({ open: false, isCancel: true });
        this.props.reset();
    };

    newPasswordSetState = (event) => {
        this.setState({ newPassword: event.target.value });
    }

    confirmPasswordSetState = (event) => {
        if (this.state.newPassword == event.target.value) {
            this.setState({ isCancel: false });
        } else {
            this.setState({ isCancel: true });
        }
    }

    
    render() {
        const { classes } = this.props;
        return (
            <MainWrapper
                history={this.props.history}
                isDisplayOn="none"
                userRoles={this.props.userRoles}
              
                >
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                  <h1 className="h2">Dashboard</h1>
                </div>
                <div>
                    <p>
                        Welcome to Hotspot Management, <b>{localStorage.getItem("username")}</b>.
                    </p>
                    <p>
                        <Button variant="contained" color="secondary" onClick={() => this.handleModalOpen()}>Change Password</Button>    
                    </p>
                    
                </div> 
                <div>
                    
                <div></div>
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={this.state.open}
                        onClose={this.handleModalClose}
                    >
                        <div style={getModalStyle()} className={classes.paper}>
                            <Typography variant="subtitle1" id="modal-title">
                                Change Password
                            </Typography>
                            <Typography variant="subheading" id="simple-modal-description">
                                <Paper>
                                    <form
                                        id="modalRegisterPackageForm"
                                        className={classes.container}
                                        onSubmit={this.props.handleSubmit(this._handleSubmit)}
                                    >
                                        <div className={classes.root}>
                                            <Grid container spacing={24}>
                                                <Grid item xs={5}>
                                                    <TextField
                                                        fullWidth={true}
                                                        name="oldPassword"
                                                        type="password"
                                                        id="oldPassword"
                                                        label="Old Password"
                                                         
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                        <div className={classes.root}>
                                            <Grid container spacing={24}>
                                                <Grid item xs={5}>
                                                    <TextField
                                                        fullWidth={true}
                                                        name="newPassword"
                                                        type="password"
                                                        id="newPassword"
                                                        label="New Password"
                                                        onChange={(e) => this.newPasswordSetState(e)}
                                                        
                                                    />
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <TextField
                                                        fullWidth={true}
                                                        name="confirmPassword"
                                                        type="password"
                                                        id="confirmPassword"
                                                        label="Confirm Password"
                                                        onChange={(e) => this.confirmPasswordSetState(e)}
                                                        
                                                    />
                                                </Grid>
                                                <Grid style={{ marginTop: '38px' }} item xs={2}>
                                                    {this.state.isCancel ? <CancelIcon style={{ marginLeft: '10px' }} /> : <CheckIcon style={{ marginLeft: '10px' }} />}
                                                </Grid>
                                            </Grid>
                                        </div>
                                        <div style={{ textAlign: 'center' }} className={classes.buttonContainer}>
                                            <Button
                                                disabled={this.state.isCancel}
                                                className={classes.buttonPackage}
                                                type="submit"
                                                variant="contained"
                                                color="primary">
                                                Save
                                            </Button>
                                        </div>
                                    </form>
                                </Paper>
                            </Typography>
                        </div>
                    </Modal>
                    <NotificationSnackBar
                        isSwitchSnackbarOn={this.state.isSwitchSnackbarOn}
                        isSnackbarError={this.state.isSnackbarError}
                        snackbarErrorMessage={this.state.snackbarErrorMessage}
                    />
                </div>
          </MainWrapper>
        );
    }
}

function validate(values) {
    const errors = {};

    required_fields.forEach(({ name, label }) => {
        if (!values[name]) {
            errors[name] = `Please provide ${label}`;
        }
    });

    return errors;
}

let SignInWithStyles = withStyles(changePasswordStyle)(Dashboard);

SignInWithStyles = reduxForm({
    validate,
    form: "changePasswordForm"
})(SignInWithStyles);

const mapStateToProps = ({ updatepassword,  userRoles,  }) => {
    return {
        updatePasswordResult: updatepassword, 
        userRoles: userRoles, 
    };
};

export default connect(
    mapStateToProps,
    { updatepassword, checkPackage, checkUserRole }
)(SignInWithStyles);



// WEBPACK FOOTER //
// ./src/components/tabs/Dashboard.js

/*
 <Bar
                    ref={this.chartReference} 
                        data={data} 
                        height={350}
                        options={{ maintainAspectRatio: false }}
                        />
                        <Bar 
                    ref={this.chartReference2}   data={data2} 
                    options={{ maintainAspectRatio: false }}
                    height={350}/> 
                    <Bar 
                    ref={this.chartReference3}   data={data3} 
                    options={{ maintainAspectRatio: false }}
                    height={450}/> 


                    <div className="d-flex"><h5 className="h2">Total Report Status</h5></div>
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                
                    <p> 
                   
                    </p>
                    </div>
                    
                    
                     
                <div className="d-flex"><h5 className="h2">Ongoing hotspot count</h5></div>
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                
                    <p>
                    
                    </p>
                    </div>
                    
                <div className="d-flex"><h5 className="h2">Hotspot Report Comparison</h5></div>
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                
                    <p>
                    
                    </p>
                    </div>
                    */